import React, { Component, useState, createRef, useCallback } from "react";
import MapGL, {
  Marker,
  Popup,
  NavigationControl,
  FullscreenControl,
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "react-map-gl-geocoder/dist/mapbox-gl-geocoder.css";
import Geocoder from "react-map-gl-geocoder";

import BankPin from "./bank-pin";
import BankInfo from "./bank-info";

import BANKS from "./banks.json";

const TOKEN =
  "pk.eyJ1IjoiZXJuZWJ1dGEiLCJhIjoiY2s2bDVwYTRlMGFwdDNncGE0ZWdjaWZzMCJ9.2PppNmYQsYZ8HDSjEGwjCA"; // Set your mapbox token here

// It's a styling object for pop-up to set map on fullscreen
const fullscreenControlStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  padding: "10px",
};

// It's a styling object for pop-up to navigation from where you can zoom in/out over the map
const navStyle = {
  position: "absolute",
  top: 36,
  left: 0,
  padding: "10px",
};

export default class Map extends Component {
  constructor(props) {
    super(props);
    // Here inside constructor i am setting the initial state for map (It's like useState in function base react)
    this.state = {
      viewport: {
        latitude: 37.785164,
        longitude: -100,
        zoom: 3.5,
        bearing: 0,
        pitch: 0,
      },
      popupInfo: null,
    };

    // ====================
    // If you want the user location should be detect automatically then just un comment the function below
    // This function is checking the user location through JS navigation
    // ====================

    // if ("geolocation" in navigator) {
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     console.log(position);
    //     this.setState({
    //       ...this.state,
    //       viewport: {
    //         ...this.state.viewport,
    //         latitude: position.coords.latitude,
    //         longitude: position.coords.longitude,
    //       },
    //     });
    //   });
    // }
  }

  // It's a function which will render/call on every viewport change
  _updateViewport = (viewport) => {
    this.setState({ viewport });
  };

  // This function puts the pin-points on map during first render of UI on all banks that are in JSON file
  _renderBankMarker = (bank, index) => {
    // Here Destructuring is happening to get coordinates
    const Cor = bank.geometry.coordinates;

    // Here I just arranged data in a new object to fullfil the marker prerequisites
    const info = {
      name: bank.properties.name,
      url: bank.properties.foodbank_url,
      telephone: bank.properties.telephone,
      email: bank.properties.email,
      address: bank.properties.address,
      longitude: Cor[0],
      latitude: Cor[1],
    };
    return (
      <Marker key={`marker-${index}`} longitude={Cor[0]} latitude={Cor[1]}>
        <BankPin size={20} onClick={() => this.setState({ popupInfo: info })} />
      </Marker>
    );
  };

  // This function is using to display the pop up when user is clicking on any pin-point on map
  _renderPopup() {
    const { popupInfo } = this.state;

    return (
      popupInfo && (
        <Popup
          tipSize={5}
          anchor="top"
          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          closeOnClick={false}
          onClose={() => this.setState({ popupInfo: null })}
        >
          <BankInfo info={popupInfo} />
        </Popup>
      )
    );
  }

  geocoderContainerRef = createRef();
  mapRef = createRef();

  render() {
    const { viewport } = this.state;

    return (
      <MapGL
        {...viewport}
        ref={this.mapRef}
        width="100%"
        height="100%"
        // mapStyle="mapbox://styles/mapbox/dark-v9"
        mapStyle="mapbox://styles/mapbox/navigation-day-v1"
        onViewportChange={this._updateViewport}
        mapboxApiAccessToken={TOKEN}
      >
        <Geocoder
          mapRef={this.mapRef}
          containerRef={this.geocoderContainerRef}
          onViewportChange={this._updateViewport}
          mapboxApiAccessToken={TOKEN}
          position="right-left"
        />

        {BANKS.map(this._renderBankMarker)}

        {this._renderPopup()}

        <div className="fullscreen" style={fullscreenControlStyle}>
          <FullscreenControl />
        </div>
        <div className="nav" style={navStyle}>
          <NavigationControl />
        </div>
      </MapGL>
    );
  }
}
